import { FC, HTMLAttributes } from "react";
import clsx from "clsx";

import SectionHeader from "../common/SectionHeader";
import RevealOnScroll from "@/components/common/RevealOnScroll";

// ----------------------------------------------------------------------------------------------

export type ITextWithCardGridSectionProps = HTMLAttributes<HTMLElement> & {
  heading?: string;
  list?: (string | undefined)[];
};

const TextWithCardGridSection: FC<ITextWithCardGridSectionProps> = (props) => {
  const { heading, list, className, ...other } = props;

  return (
    <section className={clsx("container py-14 md:py-20 xl:py-24")} {...other}>
      <div className="w-full">
        {heading && (
          <RevealOnScroll>
            <SectionHeader
              title={heading}
              align="left"
              className="mb-8 md:mb-10 lg:max-w-[440px]"
            />
          </RevealOnScroll>
        )}

        {list && list.length > 0 && (
          <div className="w-full columns-1 gap-5 space-y-5 md:columns-2 lg:columns-3 lg:gap-8 lg:space-y-7 [&>*:nth-child(even)]:bg-primary-100 [&>*:nth-child(odd)]:bg-primary-50">
            {list.map(
              (item, idx) =>
                item && (
                  <div
                    key={idx}
                    className="flex w-full break-inside-avoid flex-row items-start gap-3 rounded-2xl p-4 md:max-w-[379px] lg:gap-5 xl:p-6 2xl:p-8"
                  >
                    <p className="after:content before:content relative inline-flex gap-3 text-base font-normal text-black-900 before:relative before:mt-0.5 before:inline-flex before:size-[16px] before:shrink-0 before:justify-center before:rounded-full before:border-2 before:border-primary-900 before:bg-transparent after:absolute after:left-1 after:top-[6px] after:block after:size-2 after:shrink-0 after:rounded-full after:bg-yellow-400 lg:gap-5 lg:text-h6 lg:before:size-[22px] lg:after:left-1.5 lg:after:top-2 lg:after:size-2.5">
                      {item}
                    </p>
                  </div>
                ),
            )}
          </div>
        )}
      </div>
    </section>
  );
};

export default TextWithCardGridSection;
